import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ROLES } from "models";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { User } from "models";

const sortUsers = (users: User[]) =>
  users.sort((a, b) => {
    if (!b.first_name || !a.first_name) return 0;
    return b.first_name > a.first_name ? 1 : -1;
  });

export const useCustomerOwnersQuery = () => {
  const appointmentLocation = useAppointmentLocation();
  const canListUsers = useCan("list", "users");

  return useTypedQuery({
    queryKey: AppointmentDetailsKeys.customerOwners(appointmentLocation?.id ?? -1),
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: appointmentLocation?.id, role_id: ROLES.Receptionist }, baseUrl)).data.users,
    select: sortUsers,
    enabled: canListUsers && Boolean(appointmentLocation?.id)
  });
};
